import { AppDashboardEnv, AppEnv, ServiceType, TranslatedLabel } from '@aipb/env/model';

export class AppConfig<T extends AppEnv> {
  constructor(protected config: T) {}

  get title(): TranslatedLabel {
    return (
      this.config.title || {
        cs: '<UNKNOWN>',
        en: '<UNKNOWN>'
      }
    );
  }

  get service(): ServiceType {
    // @ts-expect-error foo
    return this.config.service;
  }

  get category(): string {
    // @ts-expect-error foo
    return this.config.category;
  }

  get logo(): string {
    // @ts-expect-error foo
    return this.config.logo;
  }

  get icon(): string {
    // @ts-expect-error foo
    return this.config.icon;
  }

  get hideInMenu(): boolean {
    return this.config.hideInMenu || false;
  }

  get dashboard(): AppDashboardEnv | undefined {
    return this.config.dashboard;
  }
}
